import { IApplicationState } from '@Site/rootReducer'

import {
  IElement
} from './types'

export const getElements = (state: IApplicationState): IElement[] => state.elements.elements
export const getCurrentPage = (state: IApplicationState): number => state.elements.page.currentPage
export const getTotalPages = (state: IApplicationState): number => state.elements.page.totalPages
export const getTotalCount = (state: IApplicationState): number => state.elements.page.totalCount
export const getShouldCheckAutoFill = (state: IApplicationState): boolean => state.elements.page.shouldCheckAutoFill
export const getHasLoadedInitially = (state: IApplicationState): boolean => state.elements.hasLoadedInitially
export const getLoading = (state: IApplicationState): boolean => state.elements.loading
